import React, { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { Grid, Box, CircularProgress, Modal, Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import { AddOutlined, Close as CloseIcon } from "@mui/icons-material";
import strings from "../../../constant/strings";
import HeadingComponent from "../HeadingComponent";
import { useStyles } from "../../../assets/styles/PatientDashboardStyles";
import TabComponent from "../../Tab";
import { daySchedule, scheduleTabs } from '../../../constant/staticLists';
import { scheduleStyles } from "../../../assets/styles/DocScheduleStyles";
import { capitalizeFirstLetter } from "../../../constant/staticHelper";
import SelectionDropdown from "../../control/SelectionDropdown";
import SlotScheduler from "../../control/SlotScheduler";
import HDFCPng from "../../../assets/img/HDFC.png";
import * as mainService from "../../../services/mainService.js";
import { StyledSecondaryButton, modalStyle } from "../../../assets/styles/CommonStyles";
import CalenderBlock from "../../control/CalenderBlock";
import DoctorSlotCreation from "./DoctorSlotCreation";
import { useDispatch, useSelector } from "react-redux";
import { getDoctorAvailableTimeAction, getSlotsByDoctorAction } from "../../../redux/schedule/doctor/doctorScheduleAction";
import moment from "moment";
import { toast } from "react-toastify";
import deleteSlot from "../../../assets/img/warning.png";
import { commonMuiStyles } from "../../../assets/styles/CommonMUIStyles";
import { getCurrencyAction } from "../../../redux/public/publicAction";
import { useLocation, useHistory } from "react-router-dom";
import { setExpiredPendingAppointments, setPendingAppointmentsModal } from "../../../redux/auth/authSlice.js";

const Schedule = () => {
  let selectedDate = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const styleClasses = commonMuiStyles();
  const scheduleClasses = scheduleStyles();
  const [tabValue, setTabValue] = useState(0);
  const [date, setDate] = useState(selectedDate);
  const [isSlotDelete, setSlotDelete] = useState(false);
  const [scheduleSelection, setScheduleSelection] = useState("d");
  const [isSlotClicked, setSlotClicked] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [localList, setLocalList] = useState([]);
  const [currencyList, setCurrency] = useState([]);
  const { userData, getSlotsByDoctorList, currencieslist, showPendingAppointmentsModal, expiredPendingAppointments } = useSelector((state) => ({
    userData: state.auth.userData,
    getSlotsByDoctorList: state.schedule.getSlotsByDoctorList,
    showPendingAppointmentsModal: state.auth.showPendingAppointmentsModal,
    expiredPendingAppointments: state.auth.expiredPendingAppointments,
    currencieslist: state.public.currencies
  }));

  const daySchedules = Object.keys(daySchedule).map(key => ({
    label: capitalizeFirstLetter(key.replace(/_/g, ' ').toLowerCase()),
    level: daySchedule[key]
  }));

  useEffect(() => {
    selectedDate = moment(new Date(selectedDate)).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
    getList(scheduleSelection, selectedDate)
  }, [])

  useEffect(() => {
    setLocalList(getSlotsByDoctorList);
  }, [getSlotsByDoctorList]);

  // useEffect(async () => { 
  //  dispatch(getCurrencyAction())
  //   currencieslist?.map((item) => {
  //     const temp = { label: item.name, level: item.enum }
  //     setCurrency((prev) => [...prev, temp])
  //     console.log("currencyList-----",currencyList)
  //   });
  // },[]);
  const location = useLocation();

useEffect(() => {
  if (userData?.token) {
    const selectedDateFormatted = moment(new Date()).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    setDate(selectedDateFormatted);
    getList(scheduleSelection, selectedDateFormatted);
  }
}, [location.pathname, userData?.token]);
  const getList = (duration, date) => {
    dispatch(getSlotsByDoctorAction({ token: userData.token, duration: duration, date: date }))
  }

  

  const handleTab = (event, newValue) => {
    setTabValue(newValue);
  };

  const dateValue = (value) => {
    //const formattedDate = moment(new Date(value)).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') 
    const formattedDate = moment(new Date(value)).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');  
    setDate(formattedDate);
    getList(scheduleSelection, formattedDate)
  };

  const handleDropdownValue = (data) => {
    setScheduleSelection(data.level);
    getList(data.level, date)
    dispatch(getSlotsByDoctorAction({ token: userData.token, duration: data.level, date: date }))

  }

  const handleSlotCreation = () => {
    setSlotClicked(!isSlotClicked);
    dispatch(getDoctorAvailableTimeAction({ date: selectedDate, token: userData.token }))
   // dispatch(getCurrencyAction())
  }

  const setSlotClick = (item) => {
    setSlotClicked(item);
    getList(scheduleSelection, selectedDate)
  }

  const handleClose = () => {
    setSlotDelete(false);
  }

  const handleDeleteClick = async () => {
    let value = { slot_id: selectedItem._id, token: userData.token }
    const res = await mainService.deleteSlotsByDoctorApi(value);
    if (res.response_type === "fail") {
      toast.error(res?.response?.message, { position: "bottom-center", closeButton: false, autoClose: 2000, style: { width: 'auto', borderRadius: 8 } });
    } else {
      setLocalList(prevList => prevList.filter(item => item._id !== selectedItem._id));
      setSelectedItem({});
      setSlotDelete(false);
      toast.success(res?.response?.message, { position: "bottom-center", closeButton: false, autoClose: 2000, style: { width: 'auto', borderRadius: 8 } });
    }
  }

  const handleSlotDelete = (value, item) => {
    setSlotDelete(value);
    setSelectedItem(item);
  }

    // ✅ Close expired appointments modal
  const handleClosePendingModal = () => {
    dispatch(setPendingAppointmentsModal(false));
    dispatch(setExpiredPendingAppointments([]));
  };

  // ✅ Go to appointments page
  const handleGoToAppointments = () => {
    handleClosePendingModal();
    history.push('/doctor/appointments');
  };

  return (
   
    <>
      {/* ✅ EXPIRED PENDING APPOINTMENTS MODAL */}
      <Dialog
        open={showPendingAppointmentsModal}
        onClose={handleClosePendingModal}
        fullWidth
        maxWidth="md"
        PaperProps={{
          style: { borderRadius: 15 }
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#fff8f0",
            borderBottom: "1px solid #ffe0b2",
            padding: "16px 24px"
          }}
        >
          <span style={{ fontWeight: 700, color: "#e65100", fontSize: 16 }}>
            ⚠️ Pending Appointments — Time Expired
          </span>
          <IconButton onClick={handleClosePendingModal} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ padding: "24px" }}>
          {/* Info text */}
          <p style={{ color: "#555", marginBottom: 20, fontSize: 14 }}>
            The following appointments were not completed and their scheduled time has passed. 
            Please review and take action.
          </p>

          {/* Appointment List */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {expiredPendingAppointments.map((item, index) => (
              <div
                key={item._id || index}
                style={{
                  border: '1px solid #ffe0b2',
                  borderRadius: 10,
                  padding: '14px 18px',
                  backgroundColor: '#fffaf5',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: 8
                }}
              >
                {/* Left — Patient Info */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                  <span style={{ fontWeight: 600, fontSize: 15, color: '#333' }}>
                    {item?.patientInfo?.name || 'Unknown Patient'}
                  </span>
                  <span style={{ fontSize: 13, color: '#777' }}>
                    {item?.patientInfo?.email || ''}
                  </span>
                </div>

                {/* Middle — Time Info */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 4, alignItems: 'center' }}>
                  <span style={{ fontSize: 13, color: '#555' }}>
                    🕒 <strong>Start:</strong> {moment(item.start_time).format('DD MMM YYYY, hh:mm A')}
                  </span>
                  <span style={{ fontSize: 13, color: '#555' }}>
                    🕒 <strong>End:</strong> {moment(item.end_time).format('DD MMM YYYY, hh:mm A')}
                  </span>
                </div>

                {/* Right — Status Badge */}
                <div>
                  <span style={{
                    backgroundColor: '#ff6b35',
                    color: 'white',
                    padding: '4px 12px',
                    borderRadius: 20,
                    fontSize: 12,
                    fontWeight: 600
                  }}>
                    Time Expired
                  </span>
                </div>
              </div>
            ))}
          </div>

          {/* Action Buttons */}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 24 }}>
            <StyledSecondaryButton onClick={handleClosePendingModal}>
              Dismiss
            </StyledSecondaryButton>
            <StyledSecondaryButton
              onClick={handleGoToAppointments}
              style={{ backgroundColor: '#e65100', color: 'white' }}
            >
              Go to Appointments
            </StyledSecondaryButton>
          </div>
        </DialogContent>
      </Dialog>
     {!isSlotClicked ? <Grid container spacing={0}>
      <Grid item xs={12} sm={8} lg={10} className={classes.mainCont}>
        <HeadingComponent text={{ "primary": strings.schedule, "secondary": strings.scheduleHeading }} />
      </Grid>
      <Grid item xs={12} sm={4} lg={2} className={classes.buttonContainer}>
        <StyledSecondaryButton
          onClick={handleSlotCreation}
          variant="contained">
          <AddOutlined />
          {strings.createSlot}
        </StyledSecondaryButton>
      </Grid>
      <Grid item xs={12} lg={12}>
        <TabComponent tabs={scheduleTabs} tabValue={tabValue} setTabValue={setTabValue} handleTab={handleTab}
          customTab={styleClasses.customTab}
          customTabIndicator={styleClasses.customTabIndicator} />
      </Grid>

      <Grid item xs={12} lg={4} className={scheduleClasses.secondaryCont}>
        <Grid className={scheduleClasses.dropdownCont}>
          <SelectionDropdown
            name="selectGender"
            list={daySchedules}
            value={scheduleSelection}
            handleDropdownValue={handleDropdownValue}
          />
        </Grid>
        <CalenderBlock dateValue={dateValue} date={date} scheduleSelection={scheduleSelection} />
      </Grid>

      <Grid item xs={12} lg={8} className={scheduleClasses.secondaryCont}>
        <SlotScheduler scheduleSelection={scheduleSelection} list={localList} tabValue={tabValue}
          setSlotDelete={handleSlotDelete} isSlotDelete={isSlotDelete} date={date}
        />
      </Grid>

    </Grid> :
      <DoctorSlotCreation
        scheduleSelection={tabValue}
        isSlotClicked={isSlotClicked}
        setSlotClicked={setSlotClick}
        //currencyList={currencyList}
      />}
      <Modal
        keepMounted
        open={isSlotDelete}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box style={modalStyle} p={2} className={scheduleClasses.modalCont}>
          <img src ={deleteSlot} alt="delete slots" className={scheduleClasses.warningImageStyle} />
          <div className={scheduleClasses.marginStyle}>Do you want to delete Slot? </div>
          <Grid container display={"flex"} justifyContent={"space-around"} mt={3} style={{ width: '100%'}}>
            <StyledSecondaryButton onClick={handleClose} className={scheduleClasses.buttonStyle}>
              Cancel
            </StyledSecondaryButton>
            <StyledSecondaryButton onClick={handleDeleteClick} className={scheduleClasses.primaryButtonStyle}>
              Delete Slot
            </StyledSecondaryButton>
          </Grid>
        </Box>
      </Modal>
    </>
  )
}

export default React.memo(Schedule);